import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

import updateStep3 from './updateStep3';
import SidePanel from './SidePanel';
import FooterButton from './FooterButton';

import validateStep3 from './validateStep3';
import messages from '../../locale/jsonMessages';
import { normalizePrice } from '../EditProfileForm/normalizePhone';
//images
import locationIcon from '/public/SiteIcons/locationIdea.svg';
import CommonFormComponent from '../CommonField/CommonFormComponent';

import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';

class Discount extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any
  };

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: true,
    };
  }

  componentDidMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillMount() {
    const { valid } = this.props;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { valid } = nextProps;
    if (valid) {
      this.setState({ isDisabled: false });
    } else {
      this.setState({ isDisabled: true });
    }
  }

  render() {
    const { handleSubmit, nextPage, previousPage, formPage, step } = this.props;
    const { formatMessage } = this.props.intl;
    const { isDisabled } = this.state;

    return (
      <div className={cx(s.stepGrid, 'discountAddon', 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.setDiscounts)}
        />
        <form onSubmit={handleSubmit}>
          <div className={s.landingMainContent}>
            <div className="oneColumnGrid">
              <Field
                name="weeklyDiscount"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.discountLabel)}
                labelText={formatMessage(messages.discountWeekly)}
                toolTipText={formatMessage(messages.weeklyDiscountTip)}
                isAddon={true}
                prefixLabel={'%'}
                normalize={normalizePrice}
              />
              <Field
                name="monthlyDiscount"
                type="text"
                component={CommonFormComponent}
                placeholder={formatMessage(messages.discountLabel)}
                labelText={formatMessage(messages.discountMonthly)}
                toolTipText={formatMessage(messages.monthlyDiscountTooltip)}
                isAddon={true}
                prefixLabel={'%'}
                normalize={normalizePrice}
                note={
                  <div>
                    <img src={locationIcon} className={cx(cs.positionRelative, cs.topMinus3)} />&nbsp;
                    <span className={cx(s.locationTipCss, cs.commonMediumText)}><FormattedMessage {...messages.discountToolTip} /></span>
                  </div>
                }
              />
            </div>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"min-max-days"}
            previousPagePath={"pricing"}
            formPage={formPage}
            step={step}
            isDisabled={isDisabled}
          />
        </form>
      </div>
    );
  }
}

Discount = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(Discount);

const mapState = (state) => ({
  listingFields: state.listingFields.data
});

const mapDispatch = {};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(Discount)));
